import {fsa, fsaError, fsaPayload, fsaPayloadByKeys} from './helpers'

import {shimLook} from '../api/eventAndLooksDataShims'

export const ADD_LOOK = 'add an hto or rental look'
export const ADD_LOOK_ITEM = 'add a product to an hto or rental look'
export const DELETE_LOOK = 'delete a rental or hto look'
export const DISPLAY_NEXT_PRODUCT_GROUP = 'display next group of products'
export const DISPLAY_PREV_PRODUCT_GROUP = 'display previous group of products'

export const GET_PARTICIPANT_LOOK = 'get the participant look'
export const getParticipantLook = fsa(GET_PARTICIPANT_LOOK)

export const GET_PARTICIPANT_LOOK_FAILURE = 'get the participant look failed'
export const getParticipantLookFailure = fsa(GET_PARTICIPANT_LOOK_FAILURE)

export const GET_PARTICIPANT_LOOK_PENDING = 'get the participant look pending'
export const getParticipantLookPending = fsa(GET_PARTICIPANT_LOOK_PENDING)

export const GET_PARTICIPANT_LOOK_SUCCESS = 'get the participant look succeeded'
export const getParticipantLookSuccess = fsaPayload(GET_PARTICIPANT_LOOK_SUCCESS)

export const CLEAR_LOOK_PRODUCTS_TRANSACTION_TYPES = 'clear transaction types of the look products'
export const clearLookProductsTransactionTypes = fsaPayloadByKeys(
  CLEAR_LOOK_PRODUCTS_TRANSACTION_TYPES,
  ['lookId'],
)

export const UPDATE_CURRENT_LOOKS = 'update current looks'
export const updateCurrentLooks = fsaPayload(UPDATE_CURRENT_LOOKS)

export const UPDATE_USER_EVENT_LOOK_ITEM = 'update user event look item for non-paid items'
export const updateUserEventLookItem = fsaPayloadByKeys(UPDATE_USER_EVENT_LOOK_ITEM, [
  'userEventLookItemId',
  'transactionType',
])

export const UPDATE_USER_EVENT_LOOK_ITEM_SUCCESS =
  'update user event look item for non-paid items succeeded'
export const updateUserEventLookItemSuccess = fsaPayload(UPDATE_USER_EVENT_LOOK_ITEM_SUCCESS)

export function addLook(lookJson) {
  const look = shimLook(lookJson)
  return {
    type: ADD_LOOK,
    hto: look.hto, // Revise in BN-163
    look,
  }
}

export function addLookItem(lookJson) {
  const look = shimLook(lookJson)
  return {
    type: ADD_LOOK_ITEM,
    lookId: look.id,
    hto: look.hto, // Revise in BN-163
    newProducts: look.products,
  }
}

export function deleteLook(lookId) {
  return {
    type: DELETE_LOOK,
    lookId,
  }
}

export const DELETE_LOOK_ITEM = 'delete look item'
export const deleteLookItem = fsaPayloadByKeys(DELETE_LOOK_ITEM, ['lookItemId', 'lookId'])

export const DELETE_LOOK_ITEM_PENDING = 'delete look item pending'
export const deleteLookItemPending = fsaPayloadByKeys(DELETE_LOOK_ITEM_PENDING, ['eventId'])

export const DELETE_LOOK_ITEM_FAILURE = 'delete look item failure'
export const deleteLookItemFailure = fsa(DELETE_LOOK_ITEM_FAILURE)

export const DELETE_LOOK_ITEM_SUCCESS = 'delete look item success'
export const deleteLookItemSuccess = fsaPayloadByKeys(DELETE_LOOK_ITEM_SUCCESS, [
  'lookItemId',
  'lookId',
])

export function displayNextProductGroup(lookId) {
  return {
    type: DISPLAY_NEXT_PRODUCT_GROUP,
    lookId,
  }
}

export function displayPrevProductGroup(lookId) {
  return {
    type: DISPLAY_PREV_PRODUCT_GROUP,
    lookId,
  }
}

export const EDIT_LOOK_NAME = 'looks/edit look name'
export const editLookName = fsaPayloadByKeys(EDIT_LOOK_NAME, ['lookId', 'lookName'])

export const EDIT_LOOK_NAME_PENDING = 'looks/edit look name pending'
export const editLookNamePending = fsa(EDIT_LOOK_NAME_PENDING)

export const EDIT_LOOK_NAME_FAILURE = 'looks/edit look name failure'
export const editLookNameFailure = fsaError(EDIT_LOOK_NAME_FAILURE)

export const EDIT_LOOK_NAME_SUCCESS = 'looks/edit look name success'
export const editLookNameSuccess = fsaPayload(EDIT_LOOK_NAME_SUCCESS)
